import { WrenchTheme } from '@wds/styles';
import { merge } from 'lodash';

const changes = {
	palette: {
		name: 'Cobalt',
		primary: {
			main: '#3081C0',
			contrast: '#FFFFFF',
			hover: '#164A7C',
			pressed: '#3081C0',
		},
		success: {
			main: '#3081C0',
			contrast: '#FFFFFF',
			hover: '#164A7C',
			pressed: '#3081C0',
		},
		muted: {
			main: '#A0A8AD',
			contrast: '#393939',
		},
	},
};

export const CobaltTheme = merge({}, WrenchTheme, changes);
